import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import point_icon from '../../static/images_ae/pointsMall/point_icon.png';
import points_all from '../../static/images_ae/pointsMall/points_all.png';
import { withRouter } from 'react-router-dom';
import { InfiniteScroll } from 'antd-mobile-v5';
import no_content_test from '../../static/images_ae/no_content_test.png';
import styles from './index.module.scss';

const api = new ApiCore();

const AePointsRecords = (props: any) => {

    
    const [list, setList] = useState<any>([]);
    
    const [hasMore, setHasMore] = useState(true);
    const [curPage, setCurPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState<any>(null);
    const [listReady, setListReady] = useState<any>(false);

    useEffect(() => {
        window.document.title = '自测记录';
    }, [])

    const getData = () => {
        return new Promise<any>((resolve, reject) => {
            if (total !== null && curPage * pageSize >= total) {
                setHasMore(false);
                resolve([]);
            }
            let _curPage = curPage;
            _curPage++;
            setCurPage(_curPage)
            api.getQuestionnaireRecordList({
                page: _curPage,
                pageSize: pageSize
            }).then((res: any) => {
                if (res.code == 0) {
                    setTotal(res.data?.total)
                    if (_curPage * pageSize >= res.data?.total) {
                        setHasMore(false);
                    }
                    resolve(res.data?.rows);
                }
            })
        })
    }

    
    async function loadMore() {
        const append = await getData();
        setList((val: any) => [...val, ...append]); // setHasMore(append.length > 0)
        setListReady(true);
    }

    const renderColor = (mScore: any) => {
        let _color = '';
        return '#031CC3';
        let score = mScore;
        if (score) {
            if (score >= 21) {
                _color = '#ff8e5c'; // 红
            } else if (score >= 14 &&score <= 20) {
                _color = '#FFC840'; // 橙
            } else if (score >= 5 &&score <= 13) {
                _color = '#80E066'; // 绿
            } else if (score >= 0 &&score <= 4) {
                _color = '#5DBDF2'; // 蓝
            }
        }
        return _color;
    }

    const toItem = (val: any) => {
        props.history.push(`/alk/testDetail?id=${val.id}`);
    }

    return (
        <div className={styles.ae_points_records}>
            <div className={styles.head}>
            </div>
            <div className={styles.body}>
                {
                    list && list.map((val: any, key: number) => 
                    (<div key={key} className={styles.body_content_item} onClick={() => { toItem(val) }}>
                        <div className={styles.body_content_item_left}>
                            <div className={styles.body_content_item_left_top}>{val.cname}</div>
                            <div className={styles.body_content_item_left_bottom}>{val.createTime ? 
                                val.createTime.replace('T', ' ') : ''
                            }</div>
                        </div>
                        <div className={styles.body_content_item_right}>
                            <div className={styles.body_content_up}>得分</div>
                            <div className={styles.body_content_down} style={{ color: renderColor(val.score)}}>{val.score}</div>
                        </div>
                    </div>))
                }
                {
                    listReady && total == 0 &&
                    <div className={styles.no_content}>
                        <img src={no_content_test} alt="" />
                    </div>
                }
                <InfiniteScroll loadMore={loadMore} hasMore={hasMore} >{''}</InfiniteScroll>
            </div>
        </div>
    )
}

export default withRouter(AePointsRecords);